var map = {
	"./city-water/1.jpg": 7079,
	"./city-water/2.jpg": 4371,
	"./city-water/3.jpg": 3661,
	"./city-water/4.jpg": 5188,
	"./city-water/5.jpg": 1089,
	"./well-water/1.jpg": 4270,
	"./well-water/10.jpg": 6178,
	"./well-water/2.jpg": 8268,
	"./well-water/3.jpg": 1540,
	"./well-water/4.jpg": 1182,
	"./well-water/5.jpg": 3701,
	"./well-water/6.jpg": 8223,
	"./well-water/7.jpg": 9772,
	"./well-water/8.jpg": 5779,
	"./well-water/9.jpg": 4540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9737;